// CANONICAL COPY (GH #7115). src/constants/obligations/obl-internal-audit.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-internal-audit',
  title: 'Plan and conduct internal ISMS audit',
  description:
    'Conduct an internal audit of the ISMS. Verify conformity to ISO 27001 requirements and effective implementation.',
  category: 'compliance',
  scfIds: ['SCF-AUD-001'],
  cadence: { frequency: '1y', anchor: 'domain' },
  // GH #6698, co-owner review. Was `strategy: 'any'`, which made this the
  // largest remaining instance of the defect this PR exists to fix.
  //
  // Under `any`, `canAutoComplete` is `passCount > 0`. So publishing a
  // document mapped to this control fulfilled the obligation on its own,
  // while `internal-audit-programme-complete` failed AND the
  // attestation "Confirm the internal ISMS audit was actually conducted" failed —
  // and Gate 5 reads only the obligation's status, so "Obligations current"
  // passed. ISO 27001 clause 9.2 read as met from a published document and nothing else.
  //
  // This is the same decision the three `obl-subprocessor-*` obligations took
  // in this PR, and the same doctrine: a published document is evidence a
  // procedure exists, never proof the activity happened.
  strategy: 'manual',
  fulfilmentCriteria: [
    {
      type: 'internal-audit-programme-complete',
      description:
        'A completed internal audit programme, or a completed internal audit within the last year, is recorded in the Internal Audit module',
    },
    { type: 'document-published', description: 'Internal audit programme or report is published' },
    {
      type: 'manual-attestation',
      description: 'Confirm the internal ISMS audit was actually conducted',
    },
  ],
  domainActions: [{ type: 'upload-artefact', label: 'Upload Evidence' }],
};
